import CoreProductInvoiceListing from 'app/shared/model/CoreProductInvoiceListing';
import Listing from 'app/shared/model/Listing';

const CoreProductInvoice = ({
    billableClickCountAvailable = false,
    billableLeadCountAvailable = false,
    leaseCountAvailable = false,
    waitlistDaysCountAvailable = false,
    boostCountAvailable = false,
    pastBoostAvailable = false,
    listingInvoices = [],
    totalCost = 0,
    totalClicks = null,
    totalLeads = null,
    totalLeases = null,
    propertyDetails = {},
    isEstimate = false,
    rocketshipAvailable = false,
    totalActiveDays = 0,
} = {}) => ({
    billableClickCountAvailable: Boolean(billableClickCountAvailable),
    billableLeadCountAvailable: Boolean(billableLeadCountAvailable),
    leaseCountAvailable: Boolean(leaseCountAvailable),
    waitlistDaysCountAvailable: Boolean(waitlistDaysCountAvailable),
    billableBoostCountAvailable: Boolean(boostCountAvailable),
    pastBoostAvailable: Boolean(pastBoostAvailable),
    totalCost: Number(totalCost),
    totalClicks: Number(totalClicks),
    totalLeads: Number(totalLeads),
    totalLeases: Number(totalLeases),
    listingInvoices: listingInvoices.map(item => CoreProductInvoiceListing(item)),
    propertyDetails: Object.keys(propertyDetails).reduce((acc, key) => {
        acc[key] = Listing(propertyDetails[key]);
        return acc;
    }, {}),
    isEstimate: Boolean(isEstimate),
    rocketshipAvailable: Boolean(rocketshipAvailable),
    totalActiveDays: Number(totalActiveDays),
});

export default CoreProductInvoice;
